// https://easings.net/

// ease IN
export function easeInSine(x) {
    return 1 - Math.cos((x * Math.PI) / 2);
}

export function easeInCubic(x) {
    return x * x * x;
}

export function easeInQuint(x) {
    return x * x * x * x * x;
}

export function easeInOutSine(x) {
    return -(Math.cos(Math.PI * x) - 1) / 2;
}

export function easeInCirc(x) {
    return 1 - Math.sqrt(1 - Math.pow(x, 2));
}

export function easeInOutQuint(x) {
    return x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2;
}

// ease OUT
export function easeOutSine(x) {
    return Math.sin((x * Math.PI) / 2);
}

export function easeOutQuad(x) {
    return 1 - (1 - x) * (1 - x);
}

export function easeOutQuint(x) {
    return 1 - Math.pow(1 - x, 5);
}

export function easeOutCubic(x) {
    return 1 - Math.pow(1 - x, 3);
}

export function easeOutExpo(x) {
    return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
}

// use the following ease animation with caution
export function easeInOutElastic(x) {
    const c5 = (2 * Math.PI) / 4.5;

    return x === 0
        ? 0
        : x === 1
            ? 1
            : x < 0.5
                ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * c5)) / 2
                : (Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * c5)) / 2 + 1;
}

export function easeOutElastic(x) {
    const c4 = (2 * Math.PI) / 3;

    return x === 0
        ? 0
        : x === 1
            ? 1
            : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1;
}